import get from 'lodash/get'
import request from '../../request'
import { createAuthorization } from '../../auth'

/**
 * Get merchandising campaigns from brooklyn
 */
export async function getLanguages ({ auth, server }) {
  const res = await request
    .get(`${server}/admin/merchandising/languages`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}
